import React from 'react';
import styles from './Switch.module.scss';
import { useAuthContext } from '../../../contexts/Auth-Context';
 
function Switch({subscribed, isChecked, handleToggle, pausedByAdmin = false}) {
    const {  platFromData, isFirstLoginDisabled} =
    useAuthContext();
    const locked = !!pausedByAdmin
      || isFirstLoginDisabled
      || (platFromData[5]?.riskLocked || platFromData[5]?.accessRight == 3)
      || localStorage.getItem('accountType') =="0"
      || platFromData[5]?.accessRight == 2;
    return (
        <div className={`${styles.switch} ${!subscribed || pausedByAdmin ? styles.unsubSwitch : ''}`}>
            <span>
                <input
                    type="checkbox"
                    id="toggleInput"
                    checked={isChecked}
                    readOnly
                />
                <button
                    className={styles.slider}
                    type="button"
                    disabled={locked}
                    title={pausedByAdmin ? 'Paused by admin' : undefined}
                    onClick={() => {
                      if (locked || !subscribed) return;
                      handleToggle(!isChecked);
                    }}
                >
                </button>
            </span>
        </div>
    );
}

export default Switch;
